import {
  Button,
  Chip,
  Collapse,
  MenuItem,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../../partials/inputForm";
import TableFormat from "../../../../partials/TableFormat";
import { formatDatetime, LANGUAGE_SUPPORT } from "../../../../utils/setting";
import Loading from "../../../loading";
// import EnhancedTableHead from './tableHead';
import Snackbar from "../../../snackbar";
import EditService from "./editService";
import { styles } from "./styles";
const headCells = [
  {
    key: "name",
    numeric: false,
    disablePadding: true,
    label: "service_admin_listservice_tablehead_name_services",
  },
  {
    key: "phone",
    numeric: false,
    disablePadding: false,
    label: "service_admin_listservice_tablehead_phone",
  },
  {
    key: "packageCode",
    numeric: false,
    disablePadding: false,
    label: "service_admin_listservice_tablehead_package",
  },
  {
    key: "packageExpired",
    numeric: false,
    disablePadding: false,
    label: "service_admin_listservice_tablehead_expired",
  },
  {
    key: "support",
    numeric: false,
    disablePadding: true,
    label: "service_admin_listservice_tablehead_support",
  },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "service_admin_listservice_tablehead_created_at",
  },
  {
    key: "isActive",
    numeric: false,
    disablePadding: true,
    label: "service_admin_listservice_tablehead_active",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];
class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      collapse: [],
      exact_filter: {
        packageCode: "",
      },
    };
    this.supportParseToString = this.supportParseToString.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    this.getListPackage();
    this.props.setStateService({ adminService: {} });
  }

  getListPackage = async () => {
    await this.props.getListPackage();
  };

  supportParseToString(jsonSupport) {
    var result = "";
    LANGUAGE_SUPPORT.forEach((n) => {
      if (jsonSupport[n] === 1) {
        result += n.charAt(0).toUpperCase() + n.slice(1) + " ";
      }
    });
    return result.substr(0, result.length - 1);
  }

  handleSubmit = (data) => {
    var { t } = this.props;
    let check = this.props.serviceFeatureDispatch.updateServiceForAdmin({
      data: data,
      serviceCode: data.no,
    });
    if (check) {
      this.mSnackbar.handleClick(
        t("service_admin_listservice_update_successfully")
      );
    } else {
      this.mSnackbar.handleClick(
        t("service_admin_listservice_update_unsuccessfully"),
        "error"
      );
    }
  };
  handleSubmitDelete = async () => {
    // var { t } = this.props;
    // let check = await this.props.serviceDispatch.deleteServices({ listServiceDelete: this.state.selected })
    // if (check) {
    //     this.mDialog.handleDialogClose();
    //     this.mSnackbar.handleClick(t('service_admin_listservice_delete_successfully'));
    //     this.setState({ selected: [] })
    // }
    // else {
    //     this.mDialog.handleDialogClose();
    //     this.mSnackbar.handleClick(t('service_admin_listservice_delete_unsuccessfully'), 'error');
    // }
  };
  isSelected = (id) => this.state.selected.indexOf(id) !== -1;
  handleOpenCollapes = (id) => {
    let { serviceList = [] } = this.props;
    let collapse = this.state.collapse;
    for (var i = 0; i <= serviceList.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  handleAddOwner = async (data) => {
    const { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.userDispatch.addOwnerSpa({
      serviceCode: data.serviceCode,
      mobile: data.mobile,
      countryCode: data.countryCode,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.handleOpenCollapes(-1);
      this.getList();
      this.mSnackbar.handleClick(t("create_success"));
    } else this.mSnackbar.handleClick(check.message, "error");
  };
  handleRemoveOwner = async (data) => {
    const { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.userDispatch.removeOwnerSpa({
      serviceCode: data.serviceCode,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.handleOpenCollapes(-1);
      this.getList();
      this.mSnackbar.handleClick(t("delete_success"));
    } else this.mSnackbar.handleClick(check.message, "error");
  };
  getList = async (payload = {}) => {
    let { t } = this.props;
    let { rowsPerPage, page, search } = this.mTable.state;
    this.loading.startLoading();
    let check = await this.props.serviceDispatch.getListServicesForAdmin({
      limit: rowsPerPage,
      page: page,
      search: search,
      sort: [["createdAt", "DESC"]],
      ...payload,
    });
    this.loading.stopLoading();
    if (check && check.code === 1) {
    } else if (check.error === 1143)
      this.mSnackbar.handleClick(t("service_admin_spa_not_found"), "error");
    else {
      this.mSnackbar.handleClick(check.message, "error");
    }
  };
  handleChangeActive = (message) => {
    this.handleOpenCollapes(-1);
    this.getList();
    this.mSnackbar.handleClick(message);
  };
  handleChange = (e) => {
    const _this = this;
    const { target } = e;
    const { exact_filter = {} } = this.state;
    exact_filter[target.name] = target.value;
    this.setState(
      {
        exact_filter: exact_filter,
      },
      function () {
        _this.getList({ ...exact_filter });
      }
    );
  };
  getPackageName = (packageCode = "") => {
    let { t } = this.props;
    const { listPackage = [] } = this.props;
    let find = {};
    if (packageCode)
      find = listPackage.find((e) => e.packageCode === packageCode) || {};
    return t(find.packageName) || "";
  };
  openServiceAccount = (payload) => {
    this.props.openServiceAccount(payload);
  };
  renderCollapse = (row, index) => {
    const { classes, t, total, ...props } = this.props;
    const { collapse = [] } = this.state;
    let service = this.props.serviceList.find((e) => e.no === row.no);
    return (
      <TableRow key={index} classes={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditService
              {...props}
              item={index}
              service={service}
              handleSubmit={this.handleSubmit}
              handleAddOwner={this.handleAddOwner}
              handleRemoveOwner={this.handleRemoveOwner}
              handleChangeActive={this.handleChangeActive}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  handleDetail = (data) => {
    let service = this.props.serviceList.find((e) => e.no === data.no);
    this.props.setStateService({ adminService: service });
    this.props.history.push({
      pathname: "/service-admin/detail",
      search: `?serviceCode=${data.no}`,
      // state: {
      //     adminService: data,
      // }
    });
  };
  actionColumn = (row, index) => {
    const { classes, t } = this.props;
    return (
      <>
        <Button
          size="small"
          className={classes.actionColumn}
          color="primary"
          variant="outlined"
          onClick={() => this.handleDetail(row)}
        >
          {t("detail")}
        </Button>
      </>
    );
  };
  getPackageExpired = (serviceRole) => {
    let { t } = this.props;
    if (serviceRole) {
      if (serviceRole.expired === 0)
        return t("service_admin_listservice_unLimit");
      else return formatDatetime(serviceRole.expired);
    } else {
      return "";
    }
  };
  filterCustom = () => {
    const { classes, t, listPackage } = this.props;
    const { exact_filter } = this.state;
    return (
      <InputFormat
        select
        label={t("module")}
        className={classes.filterTextField}
        value={exact_filter.packageCode}
        onChange={this.handleChange}
        SelectProps={{
          MenuProps: {
            className: classes.menu,
          },

          displayEmpty: true,
        }}
        name={"packageCode"}
        variant="outlined"
        size="small"
        margin="dense"
        InputProps={{
          className: classes.rootInput,
        }}
        InputLabelProps={{
          shrink: true,
        }}
      >
        <MenuItem key={""} value={""}>
          {t("all")}
        </MenuItem>
        {listPackage.map((option) => (
          <MenuItem key={option.packageCode} value={option.packageCode}>
            {option.packageName}
          </MenuItem>
        ))}
      </InputFormat>
    );
  };
  render() {
    const { classes, t, total, count, serviceList = [] } = this.props;
    const { collapse } = this.state;
    return (
      <>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          contentDialog={t(
            "service_admin_listservice_delete_service_from_list_will_delete_it_on_system"
          )}
          placeholder={t("service_admin_search_name_adress_website")}
          onDelete={this.handleSubmitDelete}
          title={t("service_admin_list_services")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          actionColumn={this.actionColumn}
          filterCustom={this.filterCustom}
          showCheckBox={false}
          rows={serviceList.map((row, index) => {
            var strSupport =
              row.support && typeof row.support === "string"
                ? this.supportParseToString(JSON.parse(row.support))
                : "";
            return {
              no: row.no,
              name: row.name,
              phone: row.phone,
              packageCode: this.getPackageName(row.packageCode),
              packageExpired: this.getPackageExpired(row.serviceRole),
              support: strSupport,
              serviceRole: row.serviceRole,
              userCode: row.userCode,
              createdAt: formatDatetime(row.createdAt),
              isActive:
                row.isActive === 1 ? (
                  <Chip
                    label={t("employees_listemployee_active")}
                    className={classes.activeChip}
                  />
                ) : (
                  <Chip label={t("employees_listemployee_inactive")} />
                ),
            };
          })}
        />
      </>
    );
  }
}
EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceList: state.service.serviceList,
  total: state.service.total,
  count: state.service.count,
  listPackage: state.packages.list,
});

const mapDispatch = (dispatch) => ({
  setStateService: dispatch.service.setState,
  serviceDispatch: dispatch.service,
  serviceFeatureDispatch: dispatch.serviceFeature,
  userDispatch: dispatch.user,
  getListPackage: dispatch.packages.getListPackage,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(EnhancedTable)));
